import { render, staticRenderFns } from "./PlanPageWidget.vue?vue&type=template&id=34bba8f9&"
import script from "./PlanPageWidget.vue?vue&type=script&lang=js&"
export * from "./PlanPageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports